import React from 'react';
import './Policy.css';

function TermsOfService() {
  return (
    <div className="policy">
      <div className="policy-header">
        <h1>TERMS OF SERVICE</h1>
        <p>please read these terms carefully before using our service</p>
      </div>
      <div className="policy-content">
        <section>
          <h2>USE OF SERVICE</h2>
          <p>by using our service, you agree to these terms and our privacy policy.</p>
        </section>
        <section>
          <h2>INTELLECTUAL PROPERTY</h2>
          <p>all content and designs created through our service remain your property.</p>
        </section>
        <section>
          <h2>USER CONTENT</h2>
          <p>you are responsible for the content you create and submit through our service.</p>
        </section>
        <section>
          <h2>LIMITATIONS</h2>
          <p>we are not liable for any damages arising from the use of our service.</p>
        </section>
      </div>
    </div>
  );
}

export default TermsOfService; 